import { render, staticRenderFns } from "./AdminSbEdit.vue?vue&type=template&id=68a7e4df&scoped=true"
import script from "./AdminSbEdit.vue?vue&type=script&lang=js"
export * from "./AdminSbEdit.vue?vue&type=script&lang=js"
import style0 from "./AdminSbEdit.vue?vue&type=style&index=0&id=68a7e4df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a7e4df",
  null
  
)

export default component.exports